const companyApi = {
  getCompanyProfile: async (companyId) => {
    if (!companyId) {
      // fallback mock for local dev but return null or throw so code handles it
      return Promise.resolve({
        name: "TRAVNOK",
        logoUrl: "https://via.placeholder.com/150",
        themeColor: "#2563eb",
      });
    }

    // If you have backend:
    // return axiosInstance.get(`/organizations/${companyId}`).then(r => r.data);

    // keep mock if needed:
    return Promise.resolve({
      id: companyId,
      name: "TRAVNOK (company " + companyId + ")",
      logoUrl: "https://via.placeholder.com/150",
      themeColor: "#2563eb",
    });
  },
  updateCompanyProfile: async (profile) => {
    // Mock API call;
    console.log("Updating company profile:", profile);
    return Promise.resolve(profile);
  },
  uploadLogo: async (file) => {
    // Mock API call;
    console.log("Uploading logo:", file.name);
    const url = URL.createObjectURL(file);
    return Promise.resolve({ logoUrl: url });
  },
};

export default companyApi;
